import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fasting_postmenopausal~1
			landing: {
				ids: ['loader-f-postmenopausal', 'age-f-postmenopausal'],
			},
		},
	},
]

export default config
